import React from 'react';
import { SimsStyleLoading } from './SimsStyleLoading';

export const Loading = (props) => {
  return <SimsStyleLoading />;
};
